import { render, staticRenderFns } from "./textType.vue?vue&type=template&id=635553c1"
import script from "./textType.vue?vue&type=script&lang=js"
export * from "./textType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports